export const paginationOptions = {
  rowsPerPageText: "Registros por página",
  rangeSeparatorText: "de",
};
